import { createSlice } from '@reduxjs/toolkit'
import { fetchTrialBalanceData } from './thunks/trialBalance';

const initialState = {
    reFetchData: false,
    data: "",
    isLoading: false,
    error: null,
}

const trialBalance = createSlice({
    name: 'TRIALBALANCESLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setReFetchData(state, action) {
            state.reFetchData = !state.reFetchData;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTrialBalanceData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchTrialBalanceData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchTrialBalanceData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
            state.data = null
        })
    }
});

export const { addSymbols, data, setReFetchData } = trialBalance.actions

export default trialBalance;